import React, { useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import LoadingSpinner from "../../loading/LoadingSpinner"
import { FirebaseContext } from "../../Firebase"
import { useIntl } from "react-intl"
import { getOrgOptions } from "../../organizationOptions/organizationOptions"
import { SchoolContent } from "../../../templates/school"

const ProspectiveStudentLandingPage = ({ }) => {
  const { profile, prospectivePreviewCode } = useContext(FirebaseContext)
  const { locale } = useIntl()

  const { allCosmicjsSchools, allCosmicjsStudentStories } = useStaticQuery(graphql`
    query {
      allCosmicjsSchools {
        edges {
          node {
            id
            title
            locale
            slug
            type
            metadata {
              school_setting_filter
              school_banner_image_alt
              school_banner_image {
                imgix_url
              }
              school_overview
              school_contact_url {
                text
                url
              }
              school_admissions_url {
                text
                url
              }
              school_google_map {
                text
                url
              }
              school_social_facebook {
                text
                url
              }
              school_social_twitter {
                text
                url
              }
              school_social_youtube {
                text
                url
              }
              school_city
              school_country
              school_state_or_region
              school_selectivity_filter
              school_size_filter
              school_setting_filter
              school_type_filter
              school_cost_filter
              school_graduate_type
              school_technical_type
              school_undergrad_type
              school_pid
            }
          }
        }
      }
      allCosmicjsStudentStories {
        edges {
          node {
            id
            title
            locale
            slug
            metadata {
              photo {
                imgix_url
              }
              photo_alt_text
              degree_level
              degree_area
              story
              quote
              highlighted_phrase
              school_reference
            }
          }
        }
      }
    }
  `)
  const schCode = prospectivePreviewCode || profile?.prospectiveSchoolCode
    
  // const schCode = '007265' // uncomment for testing with specific school code

  const orgOptions = getOrgOptions(schCode)
  if (!allCosmicjsSchools || !profile) {
    return <LoadingSpinner />
  } else if (!orgOptions) {
    return "ERROR: Unable to determine which school you're a member of. If this issue persists, please contact Wingspans support for assistance."
  }
  
  const pid = orgOptions.petersons_institution_id

  if (!pid) {
    return "ERROR: Unable to find data for your school. If this issue persists, please contact Wingspans support for assistance."
  }

  const matchingSchools = allCosmicjsSchools.edges.filter(e => e.node.metadata?.school_pid === pid && e.node.locale === locale)
  const school = matchingSchools[0].node
  const matchingStudentStoryEdges = allCosmicjsStudentStories.edges.filter(e => e.node.metadata?.school_reference === school.id && e.node.locale === locale)
  const studentStories = matchingStudentStoryEdges.map(edge => edge.node)

  return (
    <SchoolContent
      cosmicData={school}
      forProspectiveStudent={true}
      schCode={schCode}
      pageContext={{
        slug: school.slug,
        language: locale,
        pid: pid,
        ...(school.metadata &&
          school.metadata.school_enrolled_count && {
          enrolled: school.metadata.school_enrolled_count,
        }),
      }}
      studentStories={studentStories}
    />
  )
}

export default ProspectiveStudentLandingPage
